import { Route } from '@angular/router';
import { GrecoRoute } from './route';

export function buildRoute(grecoRoute: GrecoRoute): Route {
  const { modifiers, children, ...route } = grecoRoute || {};
  const ROUTE: GrecoRoute = { ...route, children: children?.map(child => buildRoute(child)) };
  return (modifiers || []).reduce((acc, modifier) => modifier(acc), ROUTE);
}
